const BASE = 'https://cenfelec.com/api/vendey-pro';
export async function messaging(path, options = {}) {
  const response = await fetch(BASE + path, {
    ...options, headers: { Accept: 'application/json', ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }), ...options.headers }
  });
  if (response.status === 204) return null;
  const result = await response.json();
  if (!response.ok || result?.ok === false) throw new Error(result?.error?.message || result?.message || `Servicio HTTP ${response.status}`);
  return result.data ?? result;
}
export async function connectMessages(onEvent) {
  const result = await messaging('/realtime/ticket', { method: 'POST', body: '{}' });
  if (!result?.ticket) throw new Error('El servicio no devolvió un ticket de conexión.');
  const socket = new WebSocket('wss://cenfelec.com/api/vendey-pro/ws?ticket=' + encodeURIComponent(result.ticket));
  socket.onmessage = event => { try { onEvent(JSON.parse(event.data)); } catch { /* Ignorar eventos incompletos. */ } };
  return socket;
}
